// Sidebar entries owned by the Reseller module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { resources, scopes } from '@vnetwork/datacentral-core/auth'
import { resellerPaths } from './paths'

// The sidebar fields Reseller's entry uses. Structurally the app's SidebarType
// (src/types/shared): src/app/nav.tsx places these entries, so a drift between
// the two fails typecheck there.
interface ResellerNavItem {
    title: string
    path: string
    rsname?: string
    require_scopes?: string[]
    visible_permission_denied?: boolean
}

export const resellerNav = {
    list: {
        title: 'reseller:sidebar_title',
        path: resellerPaths.resellersList,
        // `Resellers` is not a Keycloak resource → gate on Customers write instead, so the
        // widened API audience (CSKH, BOM, Sale) also sees the menu.
        rsname: resources.customers,
        require_scopes: [scopes.create],
        visible_permission_denied: false,
    },
} satisfies Record<string, ResellerNavItem>
